// extracted by mini-css-extract-plugin
export var chapterMarkerStyle = "toc_chapter_marker-module--chapterMarkerStyle--3Qr7-";
export var isActiveStyle = "toc_chapter_marker-module--isActiveStyle--EE8Hi";